var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userDisconnected"},[_c('p',[_vm._v("Utilisateur déconnecté")]),_c('p',[_vm._v(" Pour se reconnecter utilisez le code : "),_c('strong',[_vm._v(_vm._s(_vm.idRoom))])])])}
var staticRenderFns = []

export { render, staticRenderFns }